import { BlockStack, Layout, Page, Text } from '@shopify/polaris'

import { Footer } from '../common/Footer'
import { TabIndex, Tabs } from '../common/Tabs'
import { partnerSections } from './partnersData'
import { PartnerSectionComponent } from './PartnerSection'

export const PartnersPage = () => (
  <>
    <Tabs selected={TabIndex.Partners} />
    <Page title="PayWhirl Ecosystem Apps">
      <Layout>
        <Layout.Section>
          <BlockStack gap="800">
            <Text as="p" tone="subdued">
              Start with the strongest PayWhirl pairings, then browse integrations by the outcomes
              they support: retention, conversion, marketing, operations, and more.
            </Text>
            {partnerSections.map((section) => (
              <PartnerSectionComponent key={section.title} section={section} />
            ))}
          </BlockStack>
        </Layout.Section>
        <Layout.Section>
          <Footer />
        </Layout.Section>
      </Layout>
    </Page>
  </>
)
